module.exports = __webpack_public_path__ + "img/barvy.243d2686.webp";